import { getPreviousQuarter } from "../../utils/dateUtils";

export const REVIEW_ITEMS_CONSTANTS = {
  BREADCRUMB: {
    TITLE: "Review Items",
    PATH: "/review-items",
  },
  DEFAULT_USER: {
    USERNAME: "",
  },
  QUERY_PARAMS: {
    DEFAULT_YEAR: getPreviousQuarter().year.toString(),
    DEFAULT_QUARTER: getPreviousQuarter().quarter.toString(),
  },
  STATES: {
    LOADING: {
      MESSAGE: "Loading action items...",
    },
    ERROR: {
      MESSAGE: "Error loading action items: ",
    },
    EMPTY: {
      TITLE: "No action items found",
      SUBTITLE: "You don't have any pending reviews or approvals at this time.",
      ICON: {
        SIZE: "w-12 h-12",
        COLOR: "text-gray-400",
      },
    },
  },
  LAYOUT: {
    MAX_WIDTH: "max-w-9xl",
    PADDING: "px-4 sm:px-6 lg:px-8",
    SPACING: {
      BREADCRUMB: "mb-6",
      CONTENT: "space-y-4",
    },
  },
  HEADER: {
    COUNTER_TEXT: "items pending",
  },
};